import { SharedUtils } from "../utilities/shared-utils";
import { LegalEntityAddressInfo } from "./legal-entity-address-info";
import { EnumLegalEntityProfile, EnumLegalEntityRole, EnumLegalEntityStatus, LegalEntityBasicInfo } from "./legal-entity-basic-info";

export class LegalEntityInfo extends LegalEntityBasicInfo {

    token: string | undefined;
    membershipGroup: boolean | undefined;
    membershipGroupId: number | undefined;

    addresses: LegalEntityAddressInfo[] | undefined;

    public static parseLegalEntityInfo(stringifiedLegalEntityInfo: LegalEntityInfo): LegalEntityInfo | undefined {
        // console.log("LegalEntityInfo.ParseLegalEntityInfo(). Input legal entity: " + JSON.stringify(stringifiedLegalEntityInfo));
        if(SharedUtils.inputValueIsEmpty(stringifiedLegalEntityInfo) || SharedUtils.inputValueIsEmpty(stringifiedLegalEntityInfo.id)) {
            return undefined;
        }
        let newLegalEntityInfo: LegalEntityInfo = new LegalEntityInfo();

        if(stringifiedLegalEntityInfo.id) newLegalEntityInfo.id = stringifiedLegalEntityInfo.id;
        if(stringifiedLegalEntityInfo.statusId) newLegalEntityInfo.statusId = stringifiedLegalEntityInfo.statusId;
        if(stringifiedLegalEntityInfo.token) newLegalEntityInfo.token = stringifiedLegalEntityInfo.token;

        if (SharedUtils.inputValueIsPresent(stringifiedLegalEntityInfo.roles)) {
            newLegalEntityInfo.roles = new Array<EnumLegalEntityRole>();
            let counter: number = stringifiedLegalEntityInfo.roles?.length ?? 0;
            for (let i : number = 0; i < counter; i++) {
                newLegalEntityInfo.roles.push(stringifiedLegalEntityInfo.roles![i]);
            }
        } else {
            throw new Error("LegalEntityInfo.parseLegalEntityInfo() - ERROR - LegalEntityRoles not found.  UserLegalEntityInfo.userLegalEntityRoles: " + stringifiedLegalEntityInfo.roles);
        }

        if (SharedUtils.inputValueIsPresent(stringifiedLegalEntityInfo.rolesNew)) {
            newLegalEntityInfo.rolesNew = new Array<EnumLegalEntityRole>();
            let counter: number = stringifiedLegalEntityInfo.rolesNew?.length ?? 0;
            for (let i : number = 0; i < counter; i++) {
                newLegalEntityInfo.rolesNew.push(stringifiedLegalEntityInfo.rolesNew![i]);
            }
        }
        if(stringifiedLegalEntityInfo.profile) newLegalEntityInfo.profile = stringifiedLegalEntityInfo.profile;
        if(stringifiedLegalEntityInfo.companyName) newLegalEntityInfo.companyName = stringifiedLegalEntityInfo.companyName;
        if(stringifiedLegalEntityInfo.brandName) newLegalEntityInfo.brandName = stringifiedLegalEntityInfo.brandName;
        if(stringifiedLegalEntityInfo.legalFormId) newLegalEntityInfo.legalFormId = stringifiedLegalEntityInfo.legalFormId;
        if(stringifiedLegalEntityInfo.fiscalCode) newLegalEntityInfo.fiscalCode = stringifiedLegalEntityInfo.fiscalCode;
        if(stringifiedLegalEntityInfo.vatNumber) newLegalEntityInfo.vatNumber = stringifiedLegalEntityInfo.vatNumber;

        if (SharedUtils.inputValueIsPresent(stringifiedLegalEntityInfo.addresses)) {
            newLegalEntityInfo.addresses = new Array<LegalEntityAddressInfo>();
            let counter: number = stringifiedLegalEntityInfo.addresses?.length ?? 0;
            for (let i : number = 0; i < counter; i++) {
                if(SharedUtils.inputValueIsPresent(stringifiedLegalEntityInfo.addresses![i])) newLegalEntityInfo.addresses.push(LegalEntityAddressInfo.parseLegalEntityAddressInfo(stringifiedLegalEntityInfo.addresses![i])!);
            }
        }
        return newLegalEntityInfo;
    }

    public static getEnumLegalEntityProfileList(): EnumLegalEntityProfile[] {
        return [EnumLegalEntityProfile.BUILDING_MANAGER, EnumLegalEntityProfile.ENGINEERING_FIRM, EnumLegalEntityProfile.REAL_ESTATE_AGENCY,
            EnumLegalEntityProfile.SURVEYOR];
    }

    public static statusById(id: number): EnumLegalEntityStatus | undefined {            
        switch (id) {
            case 1: return EnumLegalEntityStatus.approval;
            case 2: return EnumLegalEntityStatus.active;
            case 3: return EnumLegalEntityStatus.refused;
            case 4: return EnumLegalEntityStatus.inactive;
            case 5: return EnumLegalEntityStatus.suspended;
            case 6: return EnumLegalEntityStatus.banned;
            case 7: return EnumLegalEntityStatus.erased;
            default: return undefined;
        }
    }

    public static statusIdByEnum(status: EnumLegalEntityStatus): number {
        switch(status) {
            case EnumLegalEntityStatus.approval: return 10;
            case EnumLegalEntityStatus.active: return 11;
            case EnumLegalEntityStatus.refused: return 12;
            case EnumLegalEntityStatus.inactive: return 13;
            case EnumLegalEntityStatus.suspended: return 14;
            case EnumLegalEntityStatus.banned: return 16;
            case EnumLegalEntityStatus.erased: return 17;
            default: return -1;
        }
    }
}